'use strict';

var _sift = require('sift');

var _sift2 = _interopRequireDefault(_sift);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _timerInfos = [];

var timerTypes = {
    TIMEOUT: 1,
    INTERVAL: 2
};

/**

 */

function _wrapTimerCallback(cb, args) {
    return function () {
        cb.apply(this, args);
    };
}

/**
 */

function _addTimer(timer, fn, type) {
    var info = {
        timer: timer,
        type: type,
        call: fn,
        stop: type === timerTypes.TIMEOUT ? clearTimeout.bind(global, timer) : clearInterval.bind(global, timer)
    };
    _timerInfos.push(info);
    return info;
}

/**
 * triggers all timers immediately. Used for testing
 */

function _triggerTimers(filter) {
    var filteredTimerInfos = _timerInfos;
    if (filter) filteredTimerInfos = filteredTimerInfos.filter(filter);
    filteredTimerInfos.forEach(function (timerInfo) {
        timerInfo.call();
    });
}

/**
 * This is a utility to be used with app code. It gives us strict control over timers that are defined in the application, making
 * it easier to test. (CC)
 */

module.exports = {

    /**
     */

    testUtils: {

        /**
         * clears all timer objects (intervals & timeouts). This is a TESTING utility. Use it wisely! (CC)
         */

        clearAllTimers: function clearAllTimers() {
            _timerInfos.forEach(function (timerInfo) {
                timerInfo.stop();
            });
            _timerInfos = [];
        },

        /**
         * triggers just intervals.
         */

        triggerAllIntervals: function triggerAllIntervals() {
            _triggerTimers((0, _sift2['default'])({ type: timerTypes.INTERVAL }));
        },

        /**
         * triggers just timeouts
         */

        triggerAllTimeouts: function triggerAllTimeouts() {
            _triggerTimers((0, _sift2['default'])({ type: timerTypes.INTERVAL }));
        },

        /**
         * timeouts & intervals
         */

        triggerAllTimers: function triggerAllTimers() {
            _triggerTimers();
        }
    },

    /**
     */

    setTimeout: function (_setTimeout) {
        function setTimeout(_x, _x2) {
            return _setTimeout.apply(this, arguments);
        }

        setTimeout.toString = function () {
            return _setTimeout.toString();
        };

        return setTimeout;
    }(function (callback, ms) {
        var fn = _wrapTimerCallback(callback, Array.prototype.slice.call(arguments, 2));
        var info;
        var timer = setTimeout(function () {
            var i = _timerInfos.indexOf(info);
            if (i > -1) _timerInfos.splice(i, 1);
            fn();
        }, ms);
        info = _addTimer(timer, fn, timerTypes.TIMEOUT);
        return timer;
    }),

    /**
     */

    setInterval: function (_setInterval) {
        function setInterval(_x3, _x4) {
            return _setInterval.apply(this, arguments);
        }

        setInterval.toString = function () {
            return _setInterval.toString();
        };

        return setInterval;
    }(function (callback, ms) {
        var fn = _wrapTimerCallback(callback, Array.prototype.slice.call(arguments, 2));
        return _addTimer(setInterval(fn, ms), fn, timerTypes.INTERVAL).timer;
    })
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/timers.js
 ** module id = 628
 ** module chunks = 0
 **/